import Catalog from "@/pages/Catalog";

export default function FBMondialCatalog() {
  return (
    <Catalog
      collectionFilter="F.B. Mondial"
      overline="F.B. Mondial"
      titleLine1="Κατάλογος"
      titleAccent="F.B. Mondial."
      subtitle="Ιταλική κληρονομιά, μοντέρνες μηχανές — η επίσημη σειρά F.B. Mondial στην Ελλάδα."
    />
  );
}
